import React, { ReactNode } from 'react';

import './gradient-dot.css';

interface Props {
    children?: ReactNode;
    width: number;
    gradientColor: GradientDotColor;
}

export const GradientDot = ({
    children,
    gradientColor = 'primary',
    width,
}: Props): JSX.Element => (
    <div
        className={`gradient-dot ${gradientColor} rounded-full flex justify-center items-center`}
        style={{
            width,
            height: width,
        }}
    >
        {children}
    </div>
);
